module.exports = __webpack_public_path__ + "static/media/128.a14520ee.mp3";